<template>
  <div class="box-unlock-bottom flex flex-col justify-center">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BoxUnlockBottom"
};
</script>

<style scoped>
.box-unlock-bottom {
  height: 7.392rem;
  flex: 0 0 7.392rem;
}
@media screen and (min-height: 1024px) {
  .box-unlock-bottom {
    height: 8.448rem;
    flex: 0 0 8.448rem;
  }
}
</style>
